// mission-lock-errors.ts
//
// Tách THUẦN từ mission-lock.ts (phase 10, lô A): 2 error class dùng chung bởi
// mission-lock.ts và mission-lock-classify-existing.ts (leaf, tránh vòng import).

export class MachineLockBusyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MachineLockBusyError";
  }
}

/** Không phân biệt được "chết hẳn" với "còn sống" ⇒ dừng, KHÔNG giành lock. */
export class MachineLockRecoveringError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MachineLockRecoveringError";
  }
}
